var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comparison-svg"},[_c('svg',{attrs:{"width":_vm.svgSize,"height":_vm.svgSize,"fill":_vm.size === 'big' || _vm.size === 'normal' ? '#e7e7e7' : '#47474B'}},[_c('use',{attrs:{"xlink:href":_vm.spritePath + '#comparison'}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }